import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { SettingsView } from "../views/SettingsView";

/**
 * Account settings as a modal.
 *
 * Settings is a detour, not a destination: you open it to change one thing and
 * go back to what you were doing. A dialog keeps the page you came from behind
 * it, so closing returns you there with no navigation and no lost scroll
 * position. It also means the collapsed icon rail doesn't have to give a
 * settings *page* anywhere to live.
 *
 * The body is the same `SettingsView` the `/settings` route renders — passed
 * `inDialog` so it drops its own page header and width cap, which this dialog
 * supplies. Keeping one component means the two surfaces can't drift.
 */
export function SettingsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Settings is long. Cap the panel to the viewport and scroll the body,
          so the title and close button stay put while the content moves. */}
      <DialogContent className="max-h-[85vh] max-w-3xl gap-0 overflow-hidden p-0">
        <DialogHeader className="px-6 pb-4 pt-6 text-left">
          <DialogTitle>Settings</DialogTitle>
          <DialogDescription>
            Manage your account settings and preferences.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[calc(85vh-6rem)] overflow-y-auto px-6 pb-6">
          <SettingsView inDialog />
        </div>
      </DialogContent>
    </Dialog>
  );
}
